module.exports = __webpack_public_path__ + "img/dynamic-24.1c8e4e3e.png";